<style scoped>
</style>

<template>
  <div class="section border border-1 border-dark pt-2 pb-2 ps-2">
    <span>
      <button class="btn btn-sm btn-primary" @click="opened = !opened">
        <i class="fa fa-bars"></i>
      </button>
      <h2 class="ms-2 section-header">データ管理</h2>
    </span>
    <CollapseTransition class="mt-2 ms-4">
      <div v-show="opened">
        <div>
          <button tabindex="-1" class="btn btn-sm btn-primary" v-on:click="onExport">エクスポート</button>
          <button tabindex="-1" class="ms-2 btn btn-sm btn-primary" v-on:click="onImport">インポート</button>
        </div>
        <div class="mt-2">
          <button tabindex="-1" class="btn btn-sm btn-secondary"
            v-bind:class="{ 'btn-danger': isResettableCount }"
            v-on:click="onResetCount"
            >参加回数(小計)をリセット</button>
          <label class="ms-2">
            <input tabindex="-1" id="resetCheck" type="checkbox" v-model="checkedToResetCount">
            リセット確認
          </label>
        </div>
        <div class="mt-2">
          <button tabindex="-1" class="btn btn-sm btn-danger"
            v-on:click="onResetAllData"
            >すべての設定やデータをリセット</button>
          <label class="ms-2">
            <input tabindex="-1" id="resetCheck" type="checkbox" v-model="checkedToResetAllData">
            リセット確認
          </label>
        </div>
      </div>
    </CollapseTransition>
    <!--
    <pre>{{$props}}</pre>
    <pre>{{$data}}</pre>
    -->
  </div>
</template>

<script>
import { CollapseTransition } from "@ivanv/vue-collapse-transition"
import Storage from '@/components/resource/Storage'

export default {
  components: {
    CollapseTransition,
  },
  props: {
    'saved': { type: Object, required: true, },
  },
  data: function() {
    return {
      opened: false,
      checkedToResetCount: false,
      checkedToResetAllData: false,
    }
  },
  computed: {
    isResettableCount() {
      return this.saved.waiting.members.some(m => 0 < m.totalSortieCount)
          || this.saved.history.members.some(m => 0 < m.totalSortieCount)
    },
  },
  methods: {
    onExport() {
      let json = JSON.stringify(Storage.load(), null, 2)
      
      navigator.clipboard.writeText(json)
      
      this.$toasted.success('データをコピーしました')
    },
    onImport() {
      navigator.clipboard.readText().then(text => {
        var saved
        
        try {
          saved = JSON.parse(text)
        }
        catch {
          this.$toasted.error('エラー: クリップボードの内容が違います')
          return
        }

        if (saved.dataVersion == undefined) {
          this.$toasted.error('エラー: クリップボードの内容が違います')
          return
        }

        Storage.save(saved)
        alert("インポートしました。ページを再読み込みします。")
        location.reload()
      })
    },
    onResetCount() {
      if (! this.checkedToResetCount) return

      this.checkedToResetCount = false

      this.saved.joined.members.forEach(m => {
        m.grandTotalSortieCount = 0
        m.totalSortieCount = 0
      })
      this.saved.waiting.members.forEach(m => {
        m.grandTotalSortieCount = 0
        m.totalSortieCount = 0
      })
      this.saved.history.members.forEach(m => {
        m.grandTotalSortieCount = 0
        m.totalSortieCount = 0
      })

      this.$toasted.success('回数をリセットしました')
    },
    onResetAllData() {
      if (! this.checkedToResetAllData) return

      Storage.clear()
      alert("リセットしました。ページを再読み込みします。")
      location.reload()
    }
  }
}
</script>
